var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'winresize '+_vm.type + (_vm.enabled?'':'disabled'),on:{"mousedown":_vm.startdrag}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /usr/src/app/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a4775f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/usr/src/app/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VWinResizer.vue
// module id = null
// module chunks = 